import {
    createStore,
    applyMiddleware,
    compose,
} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import eventsListener from './events.listener';
import eventsMiddleware from './events.middleware';
import buildBetsMiddleware from './buildbets.middleware';
import buildMultiplesMiddleware from './buildmultiples.middleware';
import analyticsMiddleware from './analytics.middleware';
import freeBetsMiddleware from './freebets.middleware'

export default function configureStore() {
    let composeEnhancers = compose;

    /* eslint-disable no-underscore-dangle */
    if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
    /* eslint-enable no-underscore-dangle */

    const store = createStore(
        rootReducer,
        composeEnhancers(
            applyMiddleware(
                thunk,
                eventsMiddleware,
                buildBetsMiddleware,
                buildMultiplesMiddleware,
                freeBetsMiddleware,
                analyticsMiddleware,
            ),
        ),
    );

    eventsListener(store)

    return store
}



// WEBPACK FOOTER //
// /src/js/App/configureStore.js